/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Chaitanya
*/

import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';

import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Table from '@components/table/Table';
import TableMobile from '@components/table/TableMobile';
import * as Layout from '@components/screen/Layout';
import CustomerBrandBudget from './components/SelectCustomerBrandBudget';
import ModalUpload from '@components/modal/ModalUpload';
import { showPopup } from '@/store/modal';
import Image from '@components/global/Image';
import StatusBadge from '@components/global/StatusBadge';
import MoreButton from '@components/navbar/MoreButton';

import { isWeb, fullWidth } from '@global/screens';
import Colors from '@global/colors';
import { currency } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import store from '@/store';
import { paramsReseted } from '@/store/params';
import { showAlert } from '@/store/global';
import {
  parseDate,
  exportCsvApi,
  hasNoAccess,
  uploadS3,
} from '@global/helpers';
import templateSubdis from '@/assets/csv/template_import_skp_internal_subdis';
import templateNonSubdis from '@/assets/csv/template_import_skp_internal_non_subdis';

const SkpInternalBudgetTableScreen = (props) => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const paramsState = useSelector((state) => state.params);
  const showAddManual = useSelector((state) => state.modal.showAddManual);
  const showImportModalSkp = useSelector(
    (state) => state.modal.showImportModalSkp,
  );
  const isDetailView = useMemo(() => {
    return props.route.params.is_detail_view ? true : false;
  }, [props.route.params]);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [detailSkpInternal, setDetailSkpInternal] = useState({});
  const [activeTab, setActiveTab] = useState(1);
  const [loadingPagination, setLoadingPagination] = useState(false);

  const getSkpInternalsBrandBudget = useApi(MsOrder.getSkpInternalsBrandBudget);
  const getSkpInternalsBrandBudgetCount = useApi(
    MsOrder.getSkpInternalsBrandBudgetCount,
  );
  const getSkpInternalDetail = useApi(MsOrder.getSkpInternalDetail);
  const createSkpInternalsBrandBudget = useApi(
    MsOrder.createSkpInternalsBrandBudget,
  );
  const getSkpInternalsBrandBudgetLogs = useApi(
    MsOrder.getSkpInternalsBrandBudgetLogs,
  );
  const getSkpInternalsBrandBudgetLogsCount = useApi(
    MsOrder.getSkpInternalsBrandBudgetLogsCount,
  );
  const deleteSkpInternalsBrandBudget = useApi(
    MsOrder.deleteSkpInternalsBrandBudget,
  );
  const recalculateSkpInternalBudgets = useApi(
    MsOrder.calculateSkpInternalsBrandBudgetBulk,
  );

  const budgetTableStructure = {
    code: {
      head: 'Customer Code',
      body: 'customer.code',
    },
    name: {
      head: 'Customer Name',
      body: 'customer.name',
    },
    ...(detailSkpInternal?.skp_type?.toLowerCase() == 'subdistributor'
      ? {
          outlet_code: {
            head: 'Outlet Code',
            body: 'outlet.code',
          },
          outlet_name: {
            head: 'Outlet Name',
            body: 'outlet.name',
          },
        }
      : {}),
    brand: {
      head: 'Brand',
      body: 'brand.name',
    },
    budget: {
      head: 'Budget Sample',
      body: 'budget_sample',
      type: 'currency',
    },
    dpp: {
      head: 'DPP',
      body: 'dpp',
      type: 'currency',
    },
  };

  const logTableStructure = {
    date: {
      head: 'Date',
      body: 'created_at',
      type: 'date',
    },
    code: {
      head: 'Customer Code',
      body: 'customer.code',
    },
    name: {
      head: 'Customer Name',
      body: 'customer.name',
    },
    ...(detailSkpInternal?.skp_type?.toLowerCase() == 'subdistributor'
      ? {
          outlet_code: {
            head: 'Outlet Code',
            body: 'outlet.code',
          },
          outlet_name: {
            head: 'Outlet Name',
            body: 'outlet.name',
          },
        }
      : {}),
    brand: {
      head: 'Brand',
      body: 'brand.name',
    },
    budget: {
      head: 'Budget Sample',
      body: 'budget_sample',
      type: 'currency',
    },
    dpp: {
      head: 'DPP',
      body: 'dpp',
      type: 'currency',
    },
    user: {
      head: 'User',
      body: 'user.name',
    },
    note: {
      head: 'Note',
      body: 'action',
    },
  };

  const hasAccessExport = !hasNoAccess([
    'superadmin',
    'general',
    'sales_admin',
    'salesman',
    'sales_supervisor',
    'branch_head',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
  ]);

  if (!isDetailView) {
    budgetTableStructure['action'] = {
      type: 'action_icon',
      actions: [
        {
          name: 'delete',
        },
      ],
    };
  }

  useEffect(() => {
    let mounted = true;
    if (mounted && props?.route?.params?.id) {
      dispatch(paramsReseted());
      if (activeTab == 2) {
        searchCustomerBrandBudgetsLog();
      } else {
        searchCustomerBrandBudgets();
      }
    }
    return () => {
      mounted = false;
      dispatch(paramsReseted());
    };
  }, [props, activeTab]);

  useEffect(() => {
    const mounted = true;
    if (mounted && props?.route?.params?.id) {
      getSkpInternalDetails(props.route.params.id);
    }
  }, [props]);

  useEffect(() => {
    try {
      if (!isWeb) {
        const menus = [];
        if (hasAccessExport) {
          menus.push({
            type: 'function',
            name: 'Export',
            callback: exportBrand,
          });
        }
        if (!isDetailView) {
          menus.push({
            type: 'function',
            name: 'Import CSV',
            callback: () =>
              dispatch(showPopup({ name: 'showImportModalSkp', value: true })),
          });
        }
        props.navigation.setOptions({
          headerRight: () => {
            return isWeb ? false : <MoreButton menu={menus} {...props} />;
          },
        });
      }
    } catch (error) {}
  }, [props.navigation]);

  const tabs = [
    { key: 1, name: 'Customer & Brand' },
    { key: 2, name: 'Log' },
  ];

  const getSkpInternalDetails = async (id) => {
    const response = await getSkpInternalDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;

      const mt = result.market_type?.code || '';
      result.skp_type = result.skp_type || mt.toLowerCase();

      setDetailSkpInternal(result);
    }
  };

  const confirmRemoveBudget = (value) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Remove Budget',
        description: 'This budget will be deleted. Do you want to proceed?',
        onCallback: () => removeBudget(value.data),
      }),
    );
  };

  const removeBudget = async (data) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const result = await deleteSkpInternalsBrandBudget.request(data?._id);
      if (result.status == 200) {
        Toast.show({
          text1: 'Successfully deleted tier',
          type: 'success',
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
      } else {
        Toast.show({
          text1: 'Budget not saved properly',
          type: 'error',
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
    searchCustomerBrandBudgets();
  };

  const searchCustomerBrandBudgets = async (isLoadMore = false, val = '') => {
    setLoading(true);
    try {
      const id = props.route.params.id;
      const params = {
        params: JSON.parse(JSON.stringify(store.getState().params)),
      };
      if (params?.params?.filter) {
        params.params.filter = { 'skp_internal.id': id };
      }
      if (
        [
          'regional_manager',
          'regional_support',
          'key_account_manager',
          'group_key_account_manager',
        ].includes(auth.user.role.code)
      ) {
        params.params.filter['sales_team.id'] = {
          $in: auth.user.sales_team.map((x) => x.id),
        };
      }
      if (val && params?.params?.filter) {
        params.params.filter['$or'] = [
          { 'customer.code': { $regex: val, $options: 'i' } },
          { 'customer.name': { $regex: val, $options: 'i' } },
          { 'outlet.code': { $regex: val, $options: 'i' } },
          { 'outlet.name': { $regex: val, $options: 'i' } },
        ];
      }
      params.params.sort = '-_id';
      if (params?.params?.skip === 0) {
        const countResponse = await getSkpInternalsBrandBudgetCount.request(
          params,
        );
        if (
          countResponse &&
          countResponse.data &&
          (countResponse.data.data || countResponse.data.data == 0)
        ) {
          setTotalData(countResponse.data.data);
        }
      }
      const response = await getSkpInternalsBrandBudget.request(params);
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data;
        if (isLoadMore) {
          setTableData(tableData.concat(result));
        } else {
          setTableData(result);
        }
      } else {
        if (isLoadMore) {
          setTableData(tableData.concat([]));
        } else {
          setTableData([]);
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const searchCustomerBrandBudgetsLog = async (
    isLoadMore = false,
    val = '',
  ) => {
    setLoading(true);
    try {
      const id = props.route.params.id;
      const params = {
        params: JSON.parse(JSON.stringify(store.getState().params)),
      };
      if (params?.params?.filter) {
        params.params.filter = { 'skp_internal.id': id };
      }
      if (val && params?.params?.filter) {
        params.params.filter['$or'] = [
          { 'customer.code': { $regex: val, $options: 'i' } },
          { 'customer.name': { $regex: val, $options: 'i' } },
          { 'outlet.code': { $regex: val, $options: 'i' } },
          { 'outlet.name': { $regex: val, $options: 'i' } },
        ];
      }
      params.params.sort = '-_id';
      if (params?.params?.skip === 0) {
        const countResponse = await getSkpInternalsBrandBudgetLogsCount.request(
          params,
        );
        if (
          countResponse &&
          countResponse.data &&
          (countResponse.data.data || countResponse.data.data == 0)
        ) {
          setTotalData(countResponse.data.data);
        }
      }
      const response = await getSkpInternalsBrandBudgetLogs.request(params);
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data;
        if (isLoadMore) {
          setTableData(tableData.concat(result));
        } else {
          setTableData(result);
        }
      } else {
        if (isLoadMore) {
          setTableData(tableData.concat([]));
        } else {
          setTableData([]);
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const onLoadMoreBudget = async (val = '') => {
    setLoadingPagination(true);
    await searchCustomerBrandBudgets(true, val);
    setLoadingPagination(false);
  };

  const onLoadMoreLog = async () => {
    setLoadingPagination(true);
    await searchCustomerBrandBudgetsLog(true);
    setLoadingPagination(false);
  };

  const saveCustomerBrandBudgets = async (payload, skp) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      payload['skp_internal'] = {
        id: skp?._id,
        name: skp?.name,
        coa_tax_id: skp?.coa_tax?.id,
      };
      const result = await createSkpInternalsBrandBudget.request(payload);
      if (result?.data?.data) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({
          text1: 'Customer and Brand Budget saved successfully',
          type: 'success',
        });
        props.navigation.navigate('SkpInternlBudgetTableScreen', {
          id: skp._id,
          name: skp?.name,
          titleScreen: skp?.name,
        });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({
          text1: 'Customer and Brand Budget not saved',
          type: 'error',
        });
      }
    } catch (error) {
      console.log(error);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const recalculteBudgets = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      if (props.route?.params?.id) {
        const response = await recalculateSkpInternalBudgets.request(
          props.route.params.id,
        );
        if (response?.data?.success) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1:
              'Customer and Brand Budget are recalculating, Results will be sent to email',
            type: 'success',
          });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Unable to recalculate',
            type: 'error',
          });
        }
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({
          text1: 'Unable to recalculate',
          type: 'error',
        });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'Unable to recalculate',
        type: 'error',
      });
    }
  };

  const exportBrand = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));

    try {
      if (props.route?.params?.id) {
        await exportCsvApi('skp-internal-brands', {
          id: props.route.params.id,
        });

        Toast.show({
          text1: 'Export Customer Brand Budget In Progress',
          type: 'success',
        });
      } else {
        Toast.show({
          text1: 'Unable to recalculate',
          type: 'error',
        });
      }
    } catch (error) {
      Toast.show({
        text1: error?.response?.data?.message || 'Unable to recalculate',
        type: 'error',
      });
    } finally {
      dispatch(showPopup({ name: 'isLoading', value: false }));
    }
  };

  const onProcessBulkUpload = async (file) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const url = await uploadS3({
        file: file || {},
        isNeedMobileSupport: true,
      });
      if (url) {
        await MsOrder.uploadListCustomerBrandBudget(props.route.params.id, {
          url,
        });
        dispatch(showPopup({ name: 'showImportModalSkp', value: false }));
        dispatch(
          showAlert({
            show: true,
            title: 'Information',
            description: 'List Customer And Brand Budget Has Been Updated',
            isConfirm: false,
            onCallback: () => {
              searchCustomerBrandBudgets();
            },
          }),
        );
      } else {
        Toast.show({
          text1: 'Failed to upload file. Please try again.',
          type: 'error',
        });
      }
    } catch (err) {
      Toast.show({
        text1: err?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    } finally {
      dispatch(showPopup({ name: 'isLoading', value: false }));
    }
  };

  const filterCustomerBySkpType = (skpType) => {
    if (!skpType) {
      return {};
    }
    if (skpType.toLowerCase() == 'subdistributor') {
      return {
        is_sub_distributor: true,
      };
    } else {
      return {
        'market_type.code': {
          $in: [skpType.toUpperCase(), skpType.toLowerCase()],
        },
      };
    }
  };

  const goBack = () => {
    if (isDetailView) {
      props.navigation.navigate('SkpInternalDetailScreen', props.route.params);
    } else {
      props.navigation.navigate('SkpInternalFormScreen', props.route.params);
    }
  };

  return (
    <Layout.Container testID="skp-internal-budget-screen">
      {isWeb ? (
        <Layout.Wrapper white={false}>
          <Layout.Back
            testID="skp-internal-budget-back-btn"
            title="Skp Internal"
            onCallback={() => goBack()}
          />
        </Layout.Wrapper>
      ) : (
        false
      )}
      {isDetailView ? (
        <View
          style={[styles.rowContainer, { justifyContent: 'space-between' }]}>
          <View
            style={[
              styles.rowContainer,
              styles.rowBorderBottom,
              {
                justifyContent: isWeb ? 'flex-start' : 'space-evenly',
                width: !isWeb ? '100%' : 'auto',
              },
            ]}>
            {tabs.map((item, idx) => (
              <TouchableOpacity
                testID={`skp-internal-budget-tab-${item.key}`}
                activeOpacity={0.6}
                style={[
                  styles.tabItem,
                  activeTab == item.key ? styles.tabItemActive : {},
                  isWeb ? { width: 180 } : {},
                ]}
                key={item.key}
                onPress={() => {
                  setActiveTab(item.key);
                  dispatch(paramsReseted());
                }}>
                <SociollaText
                  style={[
                    styles.tabText,
                    activeTab == item.key ? styles.tabTextActive : {},
                    isWeb ? { alignSelf: 'center' } : {},
                  ]}>
                  {item.name}
                </SociollaText>
              </TouchableOpacity>
            ))}
          </View>
          {isWeb && (
            <View style={{ flexDirection: 'row' }}>
              {hasAccessExport && (
                <Button
                  testID="skp-internal-budget-detail-export-btn"
                  type="default"
                  rounded={true}
                  buttonStyle={{
                    width: 100,
                    backgroundColor: Colors.blue0,
                    marginRight: 10,
                  }}
                  title={
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 14, color: Colors.white }}>
                      Export
                    </SociollaText>
                  }
                  onPress={exportBrand}
                />
              )}
            </View>
          )}
        </View>
      ) : isWeb ? (
        <Layout.Title
          testID="skp-internal-budget-title"
          title="Customer And Brand">
          <View style={{ flexDirection: 'row' }}>
            {hasAccessExport && (
              <Button
                testID="skp-internal-budget-export-btn"
                type="default"
                rounded={true}
                buttonStyle={{
                  width: 100,
                  backgroundColor: Colors.blue0,
                  marginRight: 10,
                }}
                title={
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: Colors.white }}>
                    Export
                  </SociollaText>
                }
                onPress={exportBrand}
              />
            )}
            <Button
              testID="skp-internal-budget-recalculate-btn"
              type="default"
              rounded={true}
              buttonStyle={{
                width: 100,
                backgroundColor: Colors.blue0,
                marginRight: 10,
              }}
              title={
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.white }}>
                  Recalculate
                </SociollaText>
              }
              onPress={() => recalculteBudgets()}
            />
            <Button
              testID="skp-internal-budget-add-btn"
              type="primary"
              rounded={true}
              buttonStyle={{
                width: 100,
                backgroundColor: Colors.blue1,
                marginRight: 10,
              }}
              title={
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.white }}>
                  + Add
                </SociollaText>
              }
              onPress={() =>
                dispatch(showPopup({ name: 'showAddManual', value: true }))
              }
            />
            <Button
              testID="skp-internal-budget-import-csv-btn"
              type="primary"
              rounded={true}
              buttonStyle={{ width: 120, backgroundColor: Colors.blue1 }}
              title={
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.white }}>
                  Import CSV
                </SociollaText>
              }
              onPress={() =>
                dispatch(showPopup({ name: 'showImportModalSkp', value: true }))
              }
            />
          </View>
        </Layout.Title>
      ) : (
        false
      )}
      <CustomerBrandBudget
        customerType={detailSkpInternal?.skp_type}
        show={showAddManual}
        onChange={(val) => saveCustomerBrandBudgets(val, detailSkpInternal)}
        onClose={() =>
          dispatch(showPopup({ name: 'showAddManual', value: false }))
        }
        customerFilter={filterCustomerBySkpType(detailSkpInternal?.skp_type)}
      />
      {activeTab == 1 ? (
        isWeb ? (
          <Table
            testID="skp-internal-budget-table"
            structures={budgetTableStructure}
            data={tableData}
            loading={loading}
            hasNoHide={true}
            totalData={totalData}
            skip={paramsState.skip}
            limit={paramsState.limit}
            hasCallback={true}
            showFilter={false}
            showSearch={true}
            onSearch={(val) => searchCustomerBrandBudgets(false, val)}
            searchPlaceholder={'Search By Customer...'}
            onMapAction={(value) => confirmRemoveBudget(value)}
          />
        ) : (
          <TableMobile
            testID="skp-internal-budget-table-mobile"
            loading={loading}
            tableData={tableData}
            showSearch={true}
            skip={paramsState.skip}
            limit={paramsState.limit}
            totalData={totalData}
            loadingPagination={loadingPagination}
            withLoadMore
            withFetch
            noResetOnRefresh
            onSearch={(val) => searchCustomerBrandBudgets(false, val)}
            onLoadMore={(val) => onLoadMoreBudget(val)}
            renderItem={({ data, index }) => (
              <Layout.ItemMobile
                testID={`skp-internal-budget-item-${index}`}
                key={index}
                touchable={true}
                column={true}
                style={{
                  paddingVertical: 20,
                  paddingHorizontal: 25,
                  alignItems: 'flex-start',
                }}
                left={true}>
                <View
                  style={[styles.itemSection, { alignItems: 'flex-start' }]}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 15, width: fullWidth - 140 }}>
                    {data.customer?.code ? data.customer.code : '-'}
                  </SociollaText>
                  <TouchableOpacity
                    testID={`skp-internal-budget-delete-${index}`}
                    activeOpacity={0.6}
                    onPress={() => confirmRemoveBudget({ data })}>
                    <Image
                      style={{
                        width: 14,
                        height: 16,
                      }}
                      width={14}
                      height={16}
                      source={require('@assets/img/icons/trash-grey.svg')}
                      svg={true}
                    />
                  </TouchableOpacity>
                </View>
                <SociollaText
                  style={{
                    marginTop: 12,
                    fontSize: 14,
                    color: Colors.grey2,
                  }}>
                  {data.customer?.name ? data.customer.name : '-'}
                </SociollaText>
                {detailSkpInternal?.skp_type?.toLowerCase() ==
                'subdistributor' ? (
                  <SociollaText
                    style={{
                      marginTop: 12,
                      fontSize: 14,
                      color: Colors.grey2,
                    }}>
                    {data.outlet?.name ? data.outlet.name : '-'}
                  </SociollaText>
                ) : (
                  false
                )}
                <View style={[styles.itemSection, { marginTop: 10 }]}>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <Image
                      style={{ width: 20, height: 20, bottom: 3 }}
                      svg={true}
                      source={require('@assets/img/icons/menu/catalog.svg')}
                    />
                    <SociollaText
                      style={{ fontSize: 12, type: 'bold', marginLeft: 5 }}>
                      {data.brand?.name ? data.brand.name : '-'}
                    </SociollaText>
                  </View>
                  <View style={{ flexDirection: 'row' }}>
                    <SociollaText
                      type="medium"
                      style={{
                        fontSize: 14,
                        color: Colors.blue1,
                        marginRight: 5,
                      }}>
                      {data.budget_sample
                        ? currency(data.budget_sample, true)
                        : currency(0, true)}
                    </SociollaText>
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 14, color: Colors.grey2 }}>
                      ({data.dpp ? currency(data.dpp, true) : currency(0, true)}
                      )
                    </SociollaText>
                  </View>
                </View>
              </Layout.ItemMobile>
            )}
          />
        )
      ) : (
        false
      )}
      {activeTab == 2 ? (
        isWeb ? (
          <Table
            testID="skp-internal-budget-log-table"
            structures={logTableStructure}
            data={tableData}
            loading={loading}
            hasNoHide={true}
            totalData={totalData}
            skip={paramsState.skip}
            limit={paramsState.limit}
            hasCallback={true}
            showFilter={false}
            showSearch={true}
            onSearch={(val) => searchCustomerBrandBudgetsLog(false, val)}
          />
        ) : (
          <TableMobile
            testID="skp-internal-budget-log-table-mobile"
            loading={loading}
            tableData={tableData}
            showSearch={true}
            loadingPagination={loadingPagination}
            skip={paramsState.skip}
            limit={paramsState.limit}
            totalData={totalData}
            withLoadMore
            withFetch
            noResetOnRefresh
            onSearch={(val) => searchCustomerBrandBudgetsLog(false, val)}
            onLoadMore={(val) => onLoadMoreLog(val)}
            renderItem={({ data, index }) => (
              <Layout.ItemMobile
                testID={`skp-internal-budget-log-item-${index}`}
                key={index}
                touchable={true}
                column={true}
                style={{
                  paddingVertical: 20,
                  paddingHorizontal: 25,
                  alignItems: 'flex-start',
                }}
                left={true}>
                <View
                  style={[styles.itemSection, { alignItems: 'flex-start' }]}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 15, width: fullWidth - 140 }}>
                    {data.customer?.code ? data.customer.code : '-'}
                  </SociollaText>
                  <StatusBadge status={data.action} />
                </View>
                <SociollaText
                  style={{
                    marginTop: 12,
                    fontSize: 14,
                    color: Colors.grey2,
                  }}>
                  {data.customer?.name ? data.customer.name : '-'}
                </SociollaText>
                {detailSkpInternal?.skp_type?.toLowerCase() ==
                'subdistributor' ? (
                  <SociollaText
                    style={{
                      marginTop: 12,
                      fontSize: 14,
                      color: Colors.grey2,
                    }}>
                    {data.outlet?.name ? data.outlet.name : '-'}
                  </SociollaText>
                ) : (
                  false
                )}
                <View style={[styles.itemSection, { marginTop: 10 }]}>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <Image
                      style={{ width: 20, height: 20, bottom: 3 }}
                      svg={true}
                      source={require('@assets/img/icons/menu/catalog.svg')}
                    />
                    <SociollaText
                      style={{ fontSize: 12, type: 'bold', marginLeft: 5 }}>
                      {data.brand?.name ? data.brand.name : '-'}
                    </SociollaText>
                  </View>
                  <View style={{ flexDirection: 'row' }}>
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 14, color: Colors.blue1 }}>
                      {data.budget_sample
                        ? currency(data.budget_sample, true)
                        : currency(0, true)}
                    </SociollaText>
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 14, color: Colors.grey2 }}>
                      ({data.dpp ? currency(data.dpp, true) : currency(0, true)}
                      )
                    </SociollaText>
                  </View>
                </View>
                <View style={[styles.itemSection, { marginTop: 10 }]}>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <Image
                      style={{ width: 20, height: 20, bottom: 3 }}
                      svg={true}
                      source={require('@assets/img/icons/menu/calendar.svg')}
                    />
                    <SociollaText
                      style={{ fontSize: 12, type: 'bold', marginLeft: 5 }}>
                      {data.created_at ? parseDate(data.created_at) : '-'}
                    </SociollaText>
                  </View>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: Colors.grey2 }}>
                    User: {data.user?.name ? data.user.name : '-'}
                  </SociollaText>
                </View>
              </Layout.ItemMobile>
            )}
          />
        )
      ) : (
        false
      )}
      <ModalUpload
        testID="skp-internal-budget-import-csv-modal"
        show={showImportModalSkp}
        onClose={() =>
          dispatch(showPopup({ name: 'showImportModalSkp', value: false }))
        }
        templateUrl={
          detailSkpInternal?.skp_type?.toLowerCase() == 'subdistributor'
            ? templateSubdis
            : templateNonSubdis
        }
        onUpload={onProcessBulkUpload}
        autoUploadS3={false}
        name={`skp_internal${
          detailSkpInternal?.skp_type?.toLowerCase() == 'subdistributor'
            ? '_subdis'
            : ''
        }`}
        validHeader={
          detailSkpInternal?.skp_type?.toLowerCase() == 'subdistributor'
            ? ['outlet_code', 'brand_id', 'budget_sample', 'action']
            : ['customer_code', 'brand_id', 'budget_sample', 'action']
        }
      />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
  },
  rowBorderBottom: { borderBottomColor: Colors.grey0, borderBottomWidth: 1 },
  tabItem: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 3,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabText: {
    fontSize: 14,
  },
  tabTextActive: {
    color: Colors.blue0,
    fontFamily: 'figtree-medium',
  },
  itemSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: fullWidth - 40,
  },
});

export default SkpInternalBudgetTableScreen;
